import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { parseAndFormat } from '../helpers';

export const PriceCell = ({
  price,
  justifyContent = 'flex-end',
  isBold = false,
}: {
  price: string;
  justifyContent?: string;
  isBold?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      justifyContent={justifyContent}
      alignItems="center"
      sx={{ width: '100%', height: '100%' }}
    >
      <Typography
        sx={{
          fontSize: '0.875rem',
          fontWeight: isBold ? '700 !important' : 'regular',
        }}
      >{`${parseAndFormat(price)} ${t('GLOBAL.CZ_CURRENCY')}`}</Typography>
    </Stack>
  );
};
